import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Stars from '../stars';
import './question.css';
import {bindActionCreators, compose} from "redux";
import {voteQuestionMark, voteQuestionAnswer, changeQuestionAnswer} from "../../thunks";
import connect from "react-redux/es/connect/connect";
import Answer from "../answer";

class Question extends Component {


    handleVoteMark(mark) {
        this.props.voteQuestionMark(this.props.i, this.props.id, mark);
    }

    handleVoteAnswer(event) {
        this.props.voteQuestionAnswer(this.props.i, this.props.id, event.target.value);
    }

    handleChangeAnswer(event) {
        this.props.changeQuestionAnswer(this.props.i, this.props.id, event.target.value);
    }

    render() {
        let answer;

        if(this.props.mark !== null) {
            answer = <Answer onChange={this.handleChangeAnswer.bind(this)} onBlur={this.handleVoteAnswer.bind(this)} text={this.props.answer}/>;
        }

        return (
            <div className="Question">
                <span className="Question__title">Otázka číslo {this.props.i+1}</span>
                <h2 className="Question__text">{this.props.text}</h2>
                <Stars
                    mark={this.props.mark}
                    handleVote={this.handleVoteMark.bind(this)}
                />
                {answer}
            </div>
        );
    }
}

Question.propTypes = {
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    answer: PropTypes.string,
    mark: PropTypes.oneOf([null, 1, 2, 3, 4, 5]),
    voteQuestionMark: PropTypes.func.isRequired,
    voteQuestionAnswer: PropTypes.func.isRequired,
    changeQuestionAnswer: PropTypes.func.isRequired,
};

const mapStateToProps = ({ voter }) => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
    voteQuestionMark,
    voteQuestionAnswer,
    changeQuestionAnswer,
}, dispatch);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
    withConnect,
)(Question);


// WEBPACK FOOTER //
// ./src/components/question/index.js